import { render } from "./DialogBookInDirectRefundComplete.vue?vue&type=template&id=15abb063"
import script from "./DialogBookInDirectRefundComplete.vue?vue&type=script&lang=js"
export * from "./DialogBookInDirectRefundComplete.vue?vue&type=script&lang=js"
script.render = render

export default script